module Meevo.Plugins.Register {
    export class SignatureModalController {
        static $inject = [
            "$mdDialog",
			"paymentAmount"
        ];

        signaturePad: any;

        constructor(
            private $mdDialog: ng.material.IDialogService,
            private paymentAmount: number) {
        }

        save() {
            const signature = this.signaturePad.toDataURL();
            this.$mdDialog.hide(signature);
        }

	    clear() {
            this.signaturePad.clear();
	    }

        cancel() {
            this.$mdDialog.cancel();
        }

        isSaveDisabled(): boolean {
            return this.signaturePad.isEmpty();
        }

        isClearDisabled(): boolean {
            return !this.signaturePad.isEmpty();
        }
/*
        cropSignatureCanvas() {
            let canvas = document.getElementsByTagName("canvas")[0];
            let croppedCanvas = document.createElement('canvas');
            let croppedCtx:CanvasRenderingContext2D = croppedCanvas.getContext("2d");
            
            croppedCanvas.width = canvas.width;
            croppedCanvas.height = canvas.height;
            croppedCtx.drawImage(canvas, 0, 0);
            
            let w = croppedCanvas.width;
            let h = croppedCanvas.height;
            let pix = {x:[], y:[]};
            let imageData = croppedCtx.getImageData(0,0,w,h);
            let index = 0;
            
            for (let y = 0; y < h; y++) {
                for (let x = 0; x < w; x++) {
                    index = (y * w + x) * 4;
                    if (imageData.data[index+3] > 0) {
                        pix.x.push(x);
                        pix.y.push(y);
                    }
                }
            }
            
            pix.x.sort((a,b) => a-b);
            pix.y.sort((a,b) => a-b);
            let n = pix.x.length-1;
            
            w = pix.x[n] - pix.x[0];
            h = pix.y[n] - pix.y[0];
            var cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h);
            
            croppedCanvas.width = w;
            croppedCanvas.height = h;
            croppedCtx.putImageData(cut, 0, 0);
            
            return croppedCanvas.toDataURL();
        }        
*/        
    }   

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.SignatureModalController", SignatureModalController);
}